var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex items-center whitespace-nowrap rounded border px-2 py-0.5 text-xs font-medium leading-5",class:_vm.toneClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }